import * as React from 'react';
import { Paper } from 'ui';
import styles from './no-content.scss';
import { UserProfileTranslation } from 'app/area/user-profile/constants';

interface NoContent {
  translation: UserProfileTranslation;
}

export const NoContent = (props: NoContent) => {
  return <Paper componentId={'user-no-content-paper'} className="user-profile-section-paper">
    <div className={`main-paper main-grid ${styles.wrapper}`}>
      <p className="no-content">{props.translation.no_content}</p>
    </div>
  </Paper>;
};
